import React, { useEffect, useState } from 'react'
import { Col, Row, Card, Collapse, Tooltip } from 'antd'
import { connect } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { selectInquiryDeleteEvent } from 'Store/delivery-cost/selector'
import { AppInput } from 'Components/form'
import theme, { MyTheme } from 'Components/common/Theme'
import styled from 'styled-components'
import { menuPointConfigTypeText, PointConfigType } from 'helpers/constanst'
import { PointConfigData, PointProductConfig } from 'Store/member-point/types'
import { cloneDeep } from 'lodash'
import ProductsTable from './ProductsTable'
import { InfoCircleOutlined, InfoCircleTwoTone } from '@ant-design/icons'
const { Panel } = Collapse

type Props = {
  data: PointConfigData
  onUpdate: (data: PointConfigData) => void
  addProduct?: boolean
  disableProduct?: PointProductConfig[]
} & ReduxProps

const ConfigForm: React.FunctionComponent<Props> = props => {
  const { onUpdate, data, addProduct = false, disableProduct = [] } = props

  const [formData, setFormData] = useState(cloneDeep(data))

  useEffect(() => {
    if (data) {
      setFormData(data)
    }
  }, [data])

  const onUpdateData = (val: any, key: string) => {
    onUpdate({
      ...formData,
      [key]: val,
    })
  }

  const configPoint = (
    <Row gutter={[32, 24]} justify="start" align="middle">
      <Col md={12} xs={24} className="ttr-point-type">
        <Title>เลือกรูปแบบการสะสมคะแนน</Title>
        <Row gutter={[12, 12]}>
          {menuPointConfigTypeText.map((item, key: number) => {
            return (
              <Col md={24} xs={24} onClick={() => onUpdateData(item.value, 'point_type')} key={key}>
                <CardPrice className={formData?.point_type === item.value ? 'actived' : ''}>
                  &nbsp; {item.name}
                </CardPrice>
              </Col>
            )
          })}
        </Row>
      </Col>
      <Col md={12} xs={24} className="ttr-point-condition">
        <Title>เงื่อนไขการให้คะแนน</Title>
        <Row gutter={[12, 12]}>
          <Col md={24} xs={24}>
            <AppInput
              label={
                formData?.point_type === PointConfigType.AMOUNT ? `มูลค่ายอดซื้อทุกๆ` : `จำนวนซื้อสินค้าทุกๆ`
              }
              errorMsg="ราคา"
              name={'criterion'}
              value={formData?.criterion}
              isRequired={true}
              isError={false}
              onChange={onUpdateData}
              type="number"
              resProps={{
                suffix: formData?.point_type === PointConfigType.AMOUNT ? 'บาท' : 'หน่วย',
                min: 0,
                allowClear: false,
              }}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppInput
              label="จำนวนคะแนนที่ได้รับ"
              errorMsg="ราคา"
              name={'points'}
              value={formData?.points}
              isRequired={true}
              isError={false}
              onChange={onUpdateData}
              type="number"
              resProps={{ suffix: 'คะแนน', min: 0, allowClear: false }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )

  const renderTooltip = (title: any) => {
    return (
      <Tooltip title={title} placement="right">
        {' '}
        <InfoCircleOutlined />
      </Tooltip>
    )
  }

  const configProduct = (
    <Row gutter={[8, 24]} justify="start" align="middle" className="ttr-product">
      <Col span={24}>
        <Title>
          สินค้าที่ร่วมรายการ{' '}
          {renderTooltip('สินค้าที่ร่วมรายการสะสมคะแนนเงื่อนไขนี้ จะไม่สามารถสะสมคะแนนเงื่อนไขอื่นๆได้')}
        </Title>
        <ProductsTable
          products={formData?.products || []}
          onUpdateData={(product: PointProductConfig[]) => {
            onUpdateData(product, 'products')
          }}
          disableProduct={disableProduct}
        />
      </Col>
    </Row>
  )

  const configForm = (
    <ConfigWrapper>
      <Row gutter={[32, 24]} justify="start" align="top">
        <Col md={24} xs={24}>
          {configPoint}
        </Col>
        {addProduct && (
          <Col md={24} xs={24}>
            {configProduct}
          </Col>
        )}
      </Row>
    </ConfigWrapper>
  )

  return configForm
}

const Title = styled.div`
  margin-bottom: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const ConfigWrapper = styled.div`
  width: 100%;
  //padding-left: 40px;
  border-radius: 5px;
  padding: 10px 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
`

const CardPrice = styled(Card.Grid)`
  width: 100%;
  cursor: pointer;
  text-align: center;
  &.actived {
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    span,
    div {
      color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    }
  }

  @media only screen and (max-width: 720px) {
    width: 100%;
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectInquiryDeleteEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ConfigForm)
